/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-06-14 10:16:55
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-11-21 21:11:25
 * @FilePath: \baishu_react_ui\src\utils\WidgetFilter\TextWidgetFilter.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import WidgetFilter from ".";

import get from "lodash/get";
import negate from "lodash/negate";
import includes from "lodash/includes";
import size from "lodash/size";
import concat from "lodash/concat";

import { BsyUtils } from "../Utils";
import { BsyConfig } from "../../global/BsyConfig";

export default class TextWidgetFilter extends WidgetFilter {
    _init() {
        var t = this.options
        var e = BsyConfig().CONST.FILTER_METHOD;
        t.hasEmpty && -1 < [e.IN, e.NIN].indexOf(t.method) && (t.value = concat(t.value, this._getNullValues()))
    }
    _isConfigValid() {
        var t = this.options
            , e = BsyConfig().CONST.FILTER_METHOD;
        return !(-1 < [e.EQ, e.NE, e.LK, e.ULK].indexOf(t.method)) || size(t.value) <= 1 && BsyUtils.isString(get(t.value, "[0]"))
    }
    eq(e) {
        return function (t) {
            return String(t) === String(e)
        }
    }
    ne(t) {
        return negate(this.eq(t))
    }

    in() {
        var e = arguments;
        return function (t) {
            return includes(e, t)
        }
    }
    nin() {
        return negate(this.in.apply(null, arguments))
    }
    empty() {
        var e = this;
        return function (t) {
            return includes(e._getNullValues(), t)
        }
    }
    notEmpty() {
        return negate(this.empty())
    }
    like(e) {
        return function (t) {
            return new RegExp(BsyUtils.escapeRegexp(e), "i").test(t)
        }
    }
    unlike(t) {
        return negate(this.like(t))
    }
}
